// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".block-title[data-v-6369a7e8]{margin-top:13px;margin-bottom:10px}.block-title .emoji[data-v-6369a7e8]{font-size:10px;margin-right:5px}.block-title .title[data-v-6369a7e8]{font-size:12px;font-weight:500;text-align:left;color:#54626c}", ""]);
// Exports
module.exports = exports;
